import { render, staticRenderFns } from "./legislateKnowledgeBase.vue?vue&type=template&id=6941108e&scoped=true&"
import script from "./legislateKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./legislateKnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./legislateKnowledgeBase.vue?vue&type=style&index=0&id=6941108e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941108e",
  null
  
)

export default component.exports